import type { RNG } from "./types.ts";

export const MUNDANE: readonly string[] = [
  "SAVE DOCUMENT?",
  "EJECT DISK?",
  "EXIT BASIC?",
  "PRINT TO LPT1?",
  "RUN HELLO.WORLD?",
  "LIST DIRECTORY?",
  "LOAD FROM DISK?",
  "CATALOG D1?",
  "REWIND TAPE?",
  "QUIT WITHOUT SAVING?",
  "CHANGE FONT SIZE?",
  "CONTINUE BOOT SEQUENCE?",
];

export const SYSADMIN: readonly string[] = [
  "FORMAT DRIVE C:?",
  "DELETE SYSTEM32?",
  "OVERWRITE BOOT SECTOR?",
  "DEFRAGMENT MEMORY?",
  "PURGE CACHE?",
  "DROP TABLE USERS?",
  "WIPE SWAP FILE?",
  "REVOKE ROOT ACCESS?",
  "TERMINATE PARENT PROCESS?",
  "FORK BOMB?",
  "DISABLE FIREWALL?",
  "REMOUNT USR READ-ONLY?",
];

export const COSMIC: readonly string[] = [
  "REVERSE ENTROPY?",
  "INVERT GRAVITY?",
  "RECONCILE QUANTUM STATE?",
  "COLLAPSE WAVE FUNCTION?",
  "UNRAVEL TIMELINE?",
  "DIVIDE BY ZERO?",
  "SUMMON OLD ONES?",
  "TRANSPOSE DIMENSIONS?",
  "FOLD SPACE?",
  "CONSULT THE ORACLE?",
  "RELEASE THE KRAKEN?",
  "INITIATE HEAT DEATH?",
];

const VERBS: readonly string[] = [
  "FORMAT", "DELETE", "REVERSE", "FOLD", "INVERT", "CONSUME",
  "TRANSCRIBE", "EMBALM", "NEGOTIATE", "REBOOT", "ANOINT", "EXORCISE",
];
const ADJECTIVES: readonly string[] = [
  "ETERNAL", "FORBIDDEN", "RECURSIVE", "MELANCHOLIC", "ELECTRIC",
  "WET", "INTERSTELLAR", "BEIGE", "HUNGRY", "PARALLEL",
];
const NOUNS: readonly string[] = [
  "MOON", "HARD DRIVE", "BIRD", "REGRET", "PROTOCOL",
  "CASSETTE", "SENATOR", "GLACIER", "MAINFRAME", "BREAKFAST",
];

function pick(arr: readonly string[], rng: RNG): string {
  return arr[Math.floor(rng() * arr.length)]!;
}

export function generateAbsurd(rng: RNG = Math.random): string {
  return `${pick(VERBS, rng)} ${pick(ADJECTIVES, rng)} ${pick(NOUNS, rng)}?`;
}

export function nextQuestion(round: number, rng: RNG = Math.random): string {
  if (rng() < 0.2) return generateAbsurd(rng);
  if (round <= 12) return pick(MUNDANE, rng);
  if (round <= 30) return pick(SYSADMIN, rng);
  return pick(COSMIC, rng);
}
